export default "__VITE_ASSET__b696e5c2__"